function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg210Eritrea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    style: {
      fill: "#338AF3"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    style: {
      fill: "#6DA544"
    },
    width: 512,
    height: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M0,512c-0.004,0.041,512-256.008,512-256.008L0,0V512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M140.986,156.865c-46.03,0-83.478,37.448-83.478,83.478v31.304c0,46.03,37.448,83.478,83.478,83.478  s83.478-37.448,83.478-83.478v-31.304C224.464,194.312,187.016,156.865,140.986,156.865z M193.16,271.647  c0,23.317-15.377,43.108-36.522,49.772v-34.12l22.147-22.147l-22.135-22.135l-0.012-7.879V224.69h-31.304v31.304l-22.132,22.131  l22.132,22.131v21.162c-21.144-6.664-36.521-26.455-36.521-49.772v-31.304c0-28.769,23.405-52.174,52.174-52.174  s52.174,23.405,52.174,52.174V271.647z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg210Eritrea);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHJlY3QgeD0iMCIgc3R5bGU9ImZpbGw6IzMzOEFGMzsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIi8+CjxyZWN0IHg9IjAiIHN0eWxlPSJmaWxsOiM2REE1NDQ7IiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjI1NiIvPgo8cGF0aCBzdHlsZT0iZmlsbDojRDgwMDI3OyIgZD0iTTAsNTEyYy0wLjAwNCwwLjA0MSw1MTItMjU2LjAwOCw1MTItMjU2LjAwOEwwLDBWNTEyeiIvPgo8cGF0aCBzdHlsZT0iZmlsbDojRkZEQTQ0OyIgZD0iTTE0MC45ODYsMTU2Ljg2NWMtNDYuMDMsMC04My40NzgsMzcuNDQ4LTgzLjQ3OCw4My40Nzh2MzEuMzA0YzAsNDYuMDMsMzcuNDQ4LDgzLjQ3OCw4My40NzgsODMuNDc4ICBzODMuNDc4LTM3LjQ0OCw4My40NzgtODMuNDc4di0zMS4zMDRDMjI0LjQ2NCwxOTQuMzEyLDE4Ny4wMTYsMTU2Ljg2NSwxNDAuOTg2LDE1Ni44NjV6IE0xOTMuMTYsMjcxLjY0NyAgYzAsMjMuMzE3LTE1LjM3Nyw0My4xMDgtMzYuNTIyLDQ5Ljc3MnYtMzQuMTJsMjIuMTQ3LTIyLjE0N2wtMjIuMTM1LTIyLjEzNWwtMC4wMTItNy44NzlWMjI0LjY5aC0zMS4zMDR2MzEuMzA0bC0yMi4xMzIsMjIuMTMxICBsMjIuMTMyLDIyLjEzMXYyMS4xNjJjLTIxLjE0NC02LjY2NC0zNi41MjEtMjYuNDU1LTM2LjUyMS00OS43NzJ2LTMxLjMwNGMwLTI4Ljc2OSwyMy40MDUtNTIuMTc0LDUyLjE3NC01Mi4xNzQgIHM1Mi4xNzQsMjMuNDA1LDUyLjE3NCw1Mi4xNzRWMjcxLjY0N3oiLz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };